let _generation = 0;

export function incrementAdminFetchGeneration(): number {
  return ++_generation;
}

export function getAdminFetchGeneration(): number {
  return _generation;
}
